import { render, staticRenderFns } from "./ClientOT.vue?vue&type=template&id=af94c0be&scoped=true&lang=pug"
import script from "./ClientOT.vue?vue&type=script&lang=js"
export * from "./ClientOT.vue?vue&type=script&lang=js"
import style0 from "./ClientOT.vue?vue&type=style&index=0&id=af94c0be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af94c0be",
  null
  
)

export default component.exports